import { CONSENT_MODES, CONSENT_MODE_UNSPECIFIED } from 'api/consent-modes/modes';

/**
 * Coerces CONSENT_MODE_UNSPECIFIED (the proto3 default for the ConsentMode
 * enum) to CONSENT_MODE_ACE. Mirrors Roost's runtime consent middleware.
 * A deployed Consent message with an unset "mode" field deserializes to
 * UNSPECIFIED on the wire and is treated as ACE.
 *
 * null/undefined are passed through unchanged.
 *
 * @param {string | null | undefined} consentMode
 * @returns {string | null | undefined}
 */
export default function effectiveConsentMode(consentMode) {
  if (consentMode === CONSENT_MODE_UNSPECIFIED) {
    return CONSENT_MODES.ace;
  }
  return consentMode;
}
